// extracted by mini-css-extract-plugin
export default {"text":"jKeq9JuLlg9wmR5gkm7JoA==","primary":"EthLUAxuJiWjkM-Orxowqw==","secondary":"U6MCopfAESb0oFiKw5j0Jw==","oneLine":"t5XV57alULqGYDFiP5UVJQ=="};